export default __webpack_public_path__ + "static/media/logo.00ac6c4e.svg";